export default "__VITE_ASSET__D0vfySlg__"